import React from 'react';

import App from './../app.jsx';

import Orders from './../pages/varo/orders/orders.js';
import NewOrder from './../pages/varo/orders/newOrder.js';
import EditOrder from './../pages/varo/orders/editOrder.js';
import SettingsUsers from './../pages/varo/settings/users/users.js';
import SettingsOperators from './../pages/varo/settings/operators/operators.js';
import EditOperator from './../pages/varo/settings/operators/editOperator.js';
import NewUser from './../pages/varo/settings/users/newUser.js';
import EditUser from './../pages/varo/settings/users/editUser.js';
import ChangePassword from './../pages/varo/settings/users/changePassword.js';
import ChangeCurrentUserPassword from '../pages/varo/auth/changeCurrentUserPassword.js';

import Roles from './../pages/varo/settings/roles/roles.js';
import NewRole from './../pages/varo/settings/roles/newRole.js';
import EditRole from './../pages/varo/settings/roles/editRole.js';

import Insurers from './../pages/varo/catalogs/insurers/insurers.js';
import NewInsurance from './../pages/varo/catalogs/insurers/newInsurance.js';
import EditInsurance from './../pages/varo/catalogs/insurers/editInsurance.js';

import TypeEvidences from './../pages/varo/catalogs/insurers/typeEvidences/typeEvidences.js';


import RoadsideAssistances from './../pages/varo/catalogs/roadsideAssistances/roadsideAssistances.js';
import NewRoadsideAssistance from './../pages/varo/catalogs/roadsideAssistances/newRoadsideAssistance.js';
import EditRoadsideAssistance from './../pages/varo/catalogs/roadsideAssistances/editRoadsideAssistance.js';


import Locations from './../pages/varo/catalogs/locations/locations.js';
import NewLocation from './../pages/varo/catalogs/locations/newLocation.js';
import EditLocation from './../pages/varo/catalogs/locations/editLocation.js';

import BrandsModels from './../pages/varo/catalogs/brandsModels/brandsModels.js';
import NewBrand from './../pages/varo/catalogs/brandsModels/newBrand.js';
import EditBrand from './../pages/varo/catalogs/brandsModels/editBrand.js';
import NewVehicleModel from './../pages/varo/catalogs/brandsModels/newVehicleModel.js';
import EditVehicleModel from './../pages/varo/catalogs/brandsModels/editVehicleModel.js';

import ForeignRates from './../pages/varo/catalogs/rates/foreignRates.js';
import LocalRates from './../pages/varo/catalogs/rates/localRates.js';

import Agreements from './../pages/varo/catalogs/agreements/agreements.js';
import NewAgreement from './../pages/varo/catalogs/agreements/newAgreement.js';
import EditAgreement from './../pages/varo/catalogs/agreements/editAgreement.js';

import CraneTypes from './../pages/varo/catalogs/craneTypes/craneTypes.js';
import NewCraneType from './../pages/varo/catalogs/craneTypes/newCraneType.js';
import EditCraneType from './../pages/varo/catalogs/craneTypes/editCraneType.js';


import ShieldingTypes from './../pages/varo/catalogs/shieldingTypes/shieldingTypes.js';
import NewShieldingType from './../pages/varo/catalogs/shieldingTypes/newShieldingType.js';
import EditShieldingType from './../pages/varo/catalogs/shieldingTypes/editShieldingType.js';

import Cranes from './../pages/varo/catalogs/cranes/cranes.js';
import NewCrane from './../pages/varo/catalogs/cranes/newCrane.js';
import EditCrane from './../pages/varo/catalogs/cranes/editCrane.js';

import LiftTrucks from './../pages/varo/catalogs/liftTrucks/liftTrucks.js';
import NewLiftTruck from './../pages/varo/catalogs/liftTrucks/newLiftTruck.js';
import EditLiftTruck from './../pages/varo/catalogs/liftTrucks/editLiftTruck.js';

import AssistanceVehicles from './../pages/varo/catalogs/assistanceVehicles/assistanceVehicles.js';
import NewAssistanceVehicle from './../pages/varo/catalogs/assistanceVehicles/newAssistanceVehicle.js';
import EditAssistanceVehicle from './../pages/varo/catalogs/assistanceVehicles/editAssistanceVehicle.js';

import Colors from './../pages/varo/catalogs/colors/colors.js';
import NewColor from './../pages/varo/catalogs/colors/newColor.js';
import EditColor from './../pages/varo/catalogs/colors/editColor.js';

import TestSocket from '../components/TestSocket.js';

import ConfigBilling from '../pages/varo/billing/ConfigBilling.js';
import ConfigBillingVaroExpress from '../pages/varo/billing/ConfigBillingVaroExpress.js';

import ProductKey from '../pages/varo/billing/ProductKey.js';
import UnitKey from '../pages/varo/billing/UnitKey.js';

import ConfigFolio from '../pages/varo/billing/configFolio/ConfigFolio.js';
import ConfigFolioVaroExpress  from '../pages/varo/billing/configFolio/ConfigFolioVaroExpress.js';

import ConfigSerie from '../pages/varo/billing/configSerie/ConfigSerie.js';
import ConfigSerieVaroExpress from '../pages/varo/billing/configSerie/ConfigSerieVaroExpress.js';

import CustomerSocialReason from '../pages/varo/billing/customerSocialReason/CustomerSocialReason.js';
import NewCustomerSocialReason from '../pages/varo/billing/customerSocialReason/NewCustomerSocialReason.js';
import EditCustomerSocialReason from '../pages/varo/billing/customerSocialReason/EditCustomerSocialReason.js';

import VaroExpressCustomerSocialR from '../pages/varo/billing/customerSocialReason/VaroExpressCustomerSocialR.js';
import VaroExpressNewCustomerSocialR from '../pages/varo/billing/customerSocialReason/VaroExpressNewCustomerSocialR.js';
import VaroExpressEditCustomerSocialR from '../pages/varo/billing/customerSocialReason/VaroExpressEditCustomerSocialR.js';


import FormPlugins from './../pages/form/form-plugins.js';

//Varo
import Login from '../pages/varo/auth/login.js';
import GetCoords from '../pages/varo/catalogs/rates/getCoords.js';
import OrderHistory from '../pages/varo/orders/orderHistory/orderHistory.js';

import SqlView from '../pages/varo/system/sqlView.js';
import NewTypeEvidence from '../pages/varo/catalogs/insurers/typeEvidences/newTypeEvidences.js';
import EditTypeEvidence from '../pages/varo/catalogs/insurers/typeEvidences/editTypeEvidences.js';
import Banks from '../pages/varo/catalogs/banksAndBankAccounts/banks/banks.js';
import NewBank from '../pages/varo/catalogs/banksAndBankAccounts/banks/newBank.js';
import EditBank from '../pages/varo/catalogs/banksAndBankAccounts/banks/editBank.js';
import BankAccounts from '../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/bankAccounts.js';
import NewBankAccount from '../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/newBankAccounts.js';
import EditBankAccount from '../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/editBankAccounts.js';
import DuplicateOrder from '../pages/varo/orders/duplicateOrder.js';
import OperatorSalary from '../pages/varo/reports/OperatorSalary.js';
import OrderInvoice from '../pages/varo/reports/OrderInvoice.js';
import OrderInsurance from '../pages/varo/reports/OrderInsurance.js';
import TimelineOrder from '../pages/varo/orders/timelineOrder.js';
import OrdersReceivable from '../pages/varo/reports/OrdersReceivable.js';
import OrdersPaymentsInvoices from '../pages/varo/reports/ordersPaymentsInvoices.js';
import OrdersPayments from '../pages/varo/reports/ordersPayments.js';
import OrdersInvoicesReport from '../pages/varo/reports/ordersInvoicesReport.js';

import OrdersVial from '../pages/varo/ordersVial/ordersVial.js';
import NewOrderVial from '../pages/varo/ordersVial/newOrderVial.js';
import EditOrderVial from '../pages/varo/ordersVial/editOrderVial.js';


import TypeServices from './../pages/varo/catalogs/typeServices/typeServices.js';
import NewTypeService from './../pages/varo/catalogs/typeServices/newTypeService.js';
import EditTypeService from './../pages/varo/catalogs/typeServices/editTYpeService.js';
import CreateEmptyOrdersVial from './../pages/varo/catalogs/createEmptyOrdersVial/createEmptyOrdersVial.js';

import AddCartaPorteForm from './../pages/varo/orders/orderCartaPorte/addCartaPorteForm.js';
import OrdersBilling from './../pages/varo/orderBilling/ordersBilling.js';
import AddCartaPorteFormVial from './../pages/varo/ordersVial/formOrderVial/cartaPorte/addCartaPorteFormVial.js';
import OrdersVialBilling from './../pages/varo/orderVialBilling/ordersVialBilling.js';

import AddOrderBilling from './../pages/varo/orders/orderBilling/addOrderBilling.js';


import OrdersPaymentsVaroExpress from '../pages/varo/reportsVaroExpress/ordersPaymentsVaroExpress.js';
import OrdersInvoicesReportVaroExpress from '../pages/varo/reportsVaroExpress/ordersInvoicesReportVaroExpress.js';
import OrdersPaymentsInvoicesVaroExpress from '../pages/varo/reportsVaroExpress/ordersPaymentsInvoicesVaroExpress.js';
import ProtectedRoute from "./protectedRoute.jsx";
import OperatorSalaryVaroExpress from '../pages/varo/reports/OperatorSalaryVaroExpress.js';
import NewOperatorSalaryGruas from '../pages/varo/reports/NewOperatorSalaryGruas.js'
import CranesByOrder from '../pages/varo/reports/CranesByOrder.js';
import ClerksByOrder from '../pages/varo/reports/ClerksByOrder.js';
import NearbyOrders from '../pages/varo/nearbyOrders/nearbyOrders.js';

import NewVehicleType from './../pages/varo/catalogs/brandsModels/typesVehicles/newVehicleType.js';
import EditVehicleType from './../pages/varo/catalogs/brandsModels/typesVehicles/editVehicleType.js';

function withProtection(route) {
  // Rutas que NO necesitan protección (ejemplo: login, error, 404…)
  const publicPaths = ["login", "unauthorized"];

  if (publicPaths.includes(route.path)) {
    return route.element;
  }

  return <ProtectedRoute>{route.element}</ProtectedRoute>;
}

const AppRoute = [
	{
		path: '*',
		element: <App />,
		children: [
			{
				path: 'login',
				element: <Login />
			},
      {
        path: "unauthorized",
        element: <h1>No tienes permiso para acceder</h1>,
      },
    ...[
			{
				path: 'orders',
				element: <Orders />
			},
			{
				path: 'nearby-orders',
				element: <NearbyOrders />
			},
			{
				path: 'settings/users',
				element: <SettingsUsers />
			},
			{
				path: 'settings/operators',
				element: <SettingsOperators />
			},
			{
				path: 'settings/operators/edit/:id',
				element: <EditOperator />
			},
			{
				path: 'settings/users/changePassword/:id',
				element: <ChangePassword />
			},
			{
				path: 'settings/users/newUser',
				element: <NewUser />
			},
			{
				path: 'settings/users/edit/:id',
				element: <EditUser />
			},
			{
				path: 'settings/roles',
				element: <Roles />
			},
			{
				path: 'settings/roles/newRole',
				element: <NewRole />
			},
			{
				path: 'settings/roles/edit/:id',
				element: <EditRole />
			},
			{
				path: 'catalogs/insurers',
				element: <Insurers />
			},
			{
				path: 'catalogs/insurers/newInsurance',
				element: <NewInsurance />
			},
			{
				path: 'catalogs/insurers/edit/:id',
				element: <EditInsurance />
			},
      {
				path: 'catalogs/roadsideAssistances',
				element: <RoadsideAssistances />
			},
      {
				path: 'catalogs/roadsideAssistances/newRoadsideAssistance',
				element: <NewRoadsideAssistance/>
			},
      {
				path: 'catalogs/roadsideAssistances/edit/:id',
				element: <EditRoadsideAssistance />
			},
			{
				path: 'catalogs/typeEvidences',
				element: <TypeEvidences />
			},
			{
				path: 'catalogs/typeEvidences/newTypeEvidence',
				element: <NewTypeEvidence />

			},
			{
				path: 'catalogs/typeEvidences/edit/:id',
				element: <EditTypeEvidence />
			},
			{
				path: 'catalogs/banks',
				element: <Banks />
			},
			{
				path: 'catalogs/bankAccounts',
				element: <BankAccounts />
			},
			{
				path: 'catalogs/bankAccounts',
				element: <EditTypeEvidence />
			},
			{
				path: 'catalogs/locations',
				element: <Locations />
			},
			{
				path: 'catalogs/locations/newLocation',
				element: <NewLocation />
			},
			{
				path: 'catalogs/locations/edit/:id',
				element: <EditLocation />
			},
			{
				path: 'catalogs/brandsModels',
				element: <BrandsModels />
			},
			{
				path: 'catalogs/brands/newBrand',
				element: <NewBrand />
			},
			{
				path: 'catalogs/brands/edit/:id',
				element: <EditBrand />
			},
			{
				path: 'catalogs/models/newVehicleModel',
				element: <NewVehicleModel />
			},
			{
				path: 'catalogs/models/edit/:id',
				element: <EditVehicleModel />
			},
      {
				path: 'catalogs/vehicleTypes/new',
				element: <NewVehicleType/>
			},
      {
        path: 'catalogs/vehicleTypes/edit/:id',
        element: <EditVehicleType/>
      },
			{
				path: 'orders/newOrder',
				element: <NewOrder />
			},
			{
				path: 'orders/edit/:id',
				element: <EditOrder />
			},
			{
				path: 'orders/duplicate/:id',
				element: <DuplicateOrder />
			},
      {
        path: 'orders/timeline/:id',
        element:<TimelineOrder/>
      },
			{
				path: 'orders/history/:id',
				element: <OrderHistory />
			},
			{
				path: 'catalogs/foreignRates',
				element: <ForeignRates />
			},
			{
				path: 'catalogs/localRates',
				element: <LocalRates />
			},
			{
				path: 'catalogs/agreements',
				element: <Agreements />
			},
			{
				path: 'catalogs/agreements/newAgreement',
				element: <NewAgreement />
			},
			{
				path: 'catalogs/agreements/edit/:id',
				element: <EditAgreement />
			},
			{
				path: 'catalogs/crane-types',
				element: <CraneTypes />
			},
			{
				path: 'catalogs/crane-types/newCraneType',
				element: <NewCraneType />
			},
			{
				path: 'catalogs/crane-types/edit/:id',
				element: <EditCraneType />
			},
			{
				path: 'catalogs/shieldingTypes',
				element: <ShieldingTypes />
			},
			{
				path: 'catalogs/shieldingTypes/new',
				element: <NewShieldingType />
			},
			{
				path: 'catalogs/shieldingTypes/edit/:id',
				element: <EditShieldingType />
			},
			{
				path: 'catalogs/cranes',
				element: <Cranes />
			},
			{
				path: 'catalogs/cranes/newCrane',
				element: <NewCrane />
			},
			{
				path: 'catalogs/cranes/edit/:id',
				element: <EditCrane />
			},
			{
				path: 'catalogs/assistanceVehicles',
				element: <AssistanceVehicles />
			},
			{
				path: 'catalogs/assistanceVehicles/newAssistanceVehicle',
				element: <NewAssistanceVehicle />
			},
			{
				path: 'catalogs/assistanceVehicles/edit/:id',
				element: <EditAssistanceVehicle />
			},
			{
				path: 'catalogs/liftTrucks',
				element: <LiftTrucks />
			},
			{
				path: 'catalogs/liftTrucks/newLiftTruck',
				element: <NewLiftTruck />
			},
			{
				path: 'catalogs/liftTrucks/edit/:id',
				element: <EditLiftTruck />
			},
			{
				path: 'catalogs/colors',
				element: <Colors />
			},
			{
				path: 'catalogs/colors/newColor',
				element: <NewColor />
			},
			{
				path: 'catalogs/colors/edit/:id',
				element: <EditColor />
			},
			{
				path: 'catalogs/banks/newBank',
				element: <NewBank />
			},
			{
				path: 'catalogs/banks/edit/:id',
				element: <EditBank />
			},
			{
				path: 'catalogs/bankAccounts/newBankAccount',
				element: <NewBankAccount />
			},
			{
				path: 'catalogs/bankAccounts/edit/:id',
				element: <EditBankAccount />
			},
			{
				path: 'catalogs/rates/getCoords',
				element: <GetCoords />
			},
			{
				path: 'sqlView',
				element: <SqlView />
			},
			{
				path: 'auth/changePassword',
				element: <ChangeCurrentUserPassword />
			},
			{
				path: 'reports/operators-salary',
				element: <OperatorSalary />
			},
      {
        path: 'reports/new-operators-salary-gruas',
        element: <NewOperatorSalaryGruas />
      },
      {
        path: 'reports/reports-by-cranes',
        element: <CranesByOrder />
      },
      {
        path: 'reports/clerk-by-order',
        element: <ClerksByOrder />
      },
      {
				path: 'reports/order-invoice',
				element: <OrderInvoice />
			},
      {
				path: 'reports/order-insurance',
				element: <OrderInsurance />
			},
      {
				path: 'reports/orders-receivable',
				element: <OrdersReceivable />
			},
      {
				path: 'catalogs/facturas/:id',
				element: <TestSocket />
			},
      {
        path: 'billing/config-billing',
        element: <ConfigBilling />
      } ,
      {
        path: 'billing-VaroExpress/config-billing',
        element: <ConfigBillingVaroExpress />
      },
      {
        path: 'billing/ProductKey',
        element: <ProductKey />
      }  ,
      {
        path: 'billing/UnitKey',
        element: <UnitKey />
      },   
      {
        path: 'billing/ConfigFolio',
        element: <ConfigFolio />
      },
      {
        path: 'billing-VaroExpress/ConfigFolio',
        element: <ConfigFolioVaroExpress />
      },
      {
        path: 'billing/ConfigSerie',
        element: <ConfigSerie />
      },  
      {
        path: 'billing-VaroExpress/ConfigSerie',
        element: <ConfigSerieVaroExpress />
      }, 
      {
        path: 'billing/CustomerSocialReason',
        element: <CustomerSocialReason />
      },
      {
        path: 'billing-VaroExpress/CustomerSocialReason',
        element: <VaroExpressCustomerSocialR />
      },
      {
        path: 'billing/NewCustomerSocialReason',
        element: <NewCustomerSocialReason />
			},
      {
        path: 'billing-VaroExpress/NewCustomerSocialReason',
        element: <VaroExpressNewCustomerSocialR />
			},
      {
        path: 'billing/CustomerSocialReason/edit/:id',
        element: <EditCustomerSocialReason />
			},
      {
        path: 'billing-VaroExpress/CustomerSocialReason/edit/:id',
        element: <VaroExpressEditCustomerSocialR />
			},      
      {
				path: 'reports/orders-payments-invoices',
				element: <OrdersPaymentsInvoices />
			},
      {
				path: 'reports/orders-payments',
				element: <OrdersPayments />
			},      
      {
				path: 'reports/orders-invoices',
				element: <OrdersInvoicesReport />
			},         
      {
				path: 'orders-vial',
				element: <OrdersVial />
			},
      {
				path: 'orders-vial/newOrder',
				element: <NewOrderVial />
			},
      {
				path: 'orders-vial/editOrder/:id',
				element: <EditOrderVial />
			},  
      
      {
				path: 'catalogs/type-services',
				element: <TypeServices />
			},
      {
				path: 'catalogs/type-services/newTypeService',
				element: <NewTypeService />
			},
      {
				path: 'catalogs/type-services/edit/:id',
				element: <EditTypeService />
			},
      {
				path: 'catalogs/create-empty-orders-vial',
				element: <CreateEmptyOrdersVial />
			},
      {
        path: 'facturacion-ordenes/carta-porte/:id',
        element: <AddCartaPorteForm />
      },
      {
				path: 'facturacion-ordenes',
				element: <OrdersBilling />
			},
      {
        path: 'facturacion-ordenes/invoice/:id',
        element: <AddOrderBilling />
      },
      {
        path: 'facturacion-varo-express/carta-porte/:id',
        element: <AddCartaPorteFormVial />
      },
      {
				path: 'facturacion-varo-express',
				element: <OrdersVialBilling />
			},
      {
				path: 'reports-VaroExpress/orders-payments',
				element: <OrdersPaymentsVaroExpress />
			},  
      {
				path: 'reports-VaroExpress/orders-operators',
				element: <OperatorSalaryVaroExpress />
			},  
      {
				path: 'reports-VaroExpress/orders-invoices',
				element: <OrdersInvoicesReportVaroExpress />
			},  
      {
				path: 'reports-VaroExpress/orders-payments-invoices',
				element: <OrdersPaymentsInvoicesVaroExpress />
			},    
    ].map((r) => ({
        ...r,
        element: withProtection(r),
      })),
		]
	}
];


export default AppRoute;



/**
 
import React from "react";

import App from "./../app.jsx";

import Orders from "./../pages/varo/orders/orders.js";
import NewOrder from "./../pages/varo/orders/newOrder.js";
import EditOrder from "./../pages/varo/orders/editOrder.js";
import SettingsUsers from "./../pages/varo/settings/users/users.js";
import NewUser from "./../pages/varo/settings/users/newUser.js";
import EditUser from "./../pages/varo/settings/users/editUser.js";
import ChangePassword from "./../pages/varo/settings/users/changePassword.js";
import ChangeCurrentUserPassword from "../pages/varo/auth/changeCurrentUserPassword.js";

import Roles from "./../pages/varo/settings/roles/roles.js";
import NewRole from "./../pages/varo/settings/roles/newRole.js";
import EditRole from "./../pages/varo/settings/roles/editRole.js";

import Insurers from "./../pages/varo/catalogs/insurers/insurers.js";
import NewInsurance from "./../pages/varo/catalogs/insurers/newInsurance.js";
import EditInsurance from "./../pages/varo/catalogs/insurers/editInsurance.js";

import TypeEvidences from "./../pages/varo/catalogs/insurers/typeEvidences/typeEvidences.js";

import Locations from "./../pages/varo/catalogs/locations/locations.js";
import NewLocation from "./../pages/varo/catalogs/locations/newLocation.js";
import EditLocation from "./../pages/varo/catalogs/locations/editLocation.js";

import BrandsModels from "./../pages/varo/catalogs/brandsModels/brandsModels.js";
import NewBrand from "./../pages/varo/catalogs/brandsModels/newBrand.js";
import EditBrand from "./../pages/varo/catalogs/brandsModels/editBrand.js";
import NewVehicleModel from "./../pages/varo/catalogs/brandsModels/newVehicleModel.js";
import EditVehicleModel from "./../pages/varo/catalogs/brandsModels/editVehicleModel.js";

import ForeignRates from "./../pages/varo/catalogs/rates/foreignRates.js";
import LocalRates from "./../pages/varo/catalogs/rates/localRates.js";

import Agreements from "./../pages/varo/catalogs/agreements/agreements.js";
import NewAgreement from "./../pages/varo/catalogs/agreements/newAgreement.js";
import EditAgreement from "./../pages/varo/catalogs/agreements/editAgreement.js";

import CraneTypes from "./../pages/varo/catalogs/craneTypes/craneTypes.js";
import NewCraneType from "./../pages/varo/catalogs/craneTypes/newCraneType.js";
import EditCraneType from "./../pages/varo/catalogs/craneTypes/editCraneType.js";

import ShieldingTypes from "./../pages/varo/catalogs/shieldingTypes/shieldingTypes.js";
import NewShieldingType from "./../pages/varo/catalogs/shieldingTypes/newShieldingType.js";
import EditShieldingType from "./../pages/varo/catalogs/shieldingTypes/editShieldingType.js";

import Cranes from "./../pages/varo/catalogs/cranes/cranes.js";
import NewCrane from "./../pages/varo/catalogs/cranes/newCrane.js";
import EditCrane from "./../pages/varo/catalogs/cranes/editCrane.js";

import LiftTrucks from "./../pages/varo/catalogs/liftTrucks/liftTrucks.js";
import NewLiftTruck from "./../pages/varo/catalogs/liftTrucks/newLiftTruck.js";
import EditLiftTruck from "./../pages/varo/catalogs/liftTrucks/editLiftTruck.js";

import AssistanceVehicles from "./../pages/varo/catalogs/assistanceVehicles/assistanceVehicles.js";
import NewAssistanceVehicle from "./../pages/varo/catalogs/assistanceVehicles/newAssistanceVehicle.js";
import EditAssistanceVehicle from "./../pages/varo/catalogs/assistanceVehicles/editAssistanceVehicle.js";

import Colors from "./../pages/varo/catalogs/colors/colors.js";
import NewColor from "./../pages/varo/catalogs/colors/newColor.js";
import EditColor from "./../pages/varo/catalogs/colors/editColor.js";

import FormPlugins from "./../pages/form/form-plugins.js";

//Varo
import Login from "../pages/varo/auth/login.js";
import GetCoords from "../pages/varo/catalogs/rates/getCoords.js";
import OrderHistory from "../pages/varo/orders/orderHistory/orderHistory.js";

import SqlView from "../pages/varo/system/sqlView.js";
import NewTypeEvidence from "../pages/varo/catalogs/insurers/typeEvidences/newTypeEvidences.js";
import EditTypeEvidence from "../pages/varo/catalogs/insurers/typeEvidences/editTypeEvidences.js";
import Banks from "../pages/varo/catalogs/banksAndBankAccounts/banks/banks.js";
import NewBank from "../pages/varo/catalogs/banksAndBankAccounts/banks/newBank.js";
import EditBank from "../pages/varo/catalogs/banksAndBankAccounts/banks/editBank.js";
import BankAccounts from "../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/bankAccounts.js";
import NewBankAccount from "../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/newBankAccounts.js";
import EditBankAccount from "../pages/varo/catalogs/banksAndBankAccounts/bankAccounts/editBankAccounts.js";
import DuplicateOrder from "../pages/varo/orders/duplicateOrder.js";
import OperatorSalary from "../pages/varo/reports/OperatorSalary.js";
import { Navigate } from "react-router-dom";

import { useEffect, useState } from "react";
import axiosClient from './axios.js';

let routesConfig = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "settings/users",
        element: <SettingsUsers />,
      },
      {
        path: "settings/users/changePassword/:id",
        element: <ChangePassword />,
      },
      {
        path: "settings/users/newUser",
        element: <NewUser />,
      },
      {
        path: "settings/users/edit/:id",
        element: <EditUser />,
      },
      {
        path: "settings/roles",
        element: <Roles />,
      },
      {
        path: "settings/roles/newRole",
        element: <NewRole />,
      },
      {
        path: "settings/roles/edit/:id",
        element: <EditRole />,
      },
      {
        path: "catalogs/insurers",
        element: <Insurers />,
      },
      {
        path: "catalogs/insurers/newInsurance",
        element: <NewInsurance />,
      },
      {
        path: "catalogs/insurers/edit/:id",
        element: <EditInsurance />,
      },
      {
        path: "catalogs/typeEvidences",
        element: <TypeEvidences />,
      },
      {
        path: "catalogs/typeEvidences/newTypeEvidence",
        element: <NewTypeEvidence />,
      },
      {
        path: "catalogs/typeEvidences/edit/:id",
        element: <EditTypeEvidence />,
      },
      {
        path: "catalogs/banks",
        element: <Banks />,
      },
      {
        path: "catalogs/bankAccounts",
        element: <BankAccounts />,
      },
      {
        path: "catalogs/bankAccounts",
        element: <EditTypeEvidence />,
      },
      {
        path: "catalogs/locations",
        element: <Locations />,
      },
      {
        path: "catalogs/locations/newLocation",
        element: <NewLocation />,
      },
      {
        path: "catalogs/locations/edit/:id",
        element: <EditLocation />,
      },
      {
        path: "catalogs/brandsModels",
        element: <BrandsModels />,
      },
      {
        path: "catalogs/brands/newBrand",
        element: <NewBrand />,
      },
      {
        path: "catalogs/brands/edit/:id",
        element: <EditBrand />,
      },
      {
        path: "catalogs/models/newVehicleModel",
        element: <NewVehicleModel />,
      },
      {
        path: "catalogs/models/edit/:id",
        element: <EditVehicleModel />,
      },
      {
        path: "orders/newOrder",
        element: <NewOrder />,
      },
      {
        path: "orders/edit/:id",
        element: <EditOrder />,
      },
      {
        path: "orders/duplicate/:id",
        element: <DuplicateOrder />,
      },
      {
        path: "orders/history/:id",
        element: <OrderHistory />,
      },
      {
        path: "catalogs/foreignRates",
        element: <ForeignRates />,
      },
      {
        path: "catalogs/localRates",
        element: <LocalRates />,
      },
      {
        path: "catalogs/agreements",
        element: <Agreements />,
      },
      {
        path: "catalogs/agreements/newAgreement",
        element: <NewAgreement />,
      },
      {
        path: "catalogs/agreements/edit/:id",
        element: <EditAgreement />,
      },
      {
        path: "catalogs/crane-types",
        element: <CraneTypes />,
      },
      {
        path: "catalogs/crane-types/newCraneType",
        element: <NewCraneType />,
      },
      {
        path: "catalogs/crane-types/edit/:id",
        element: <EditCraneType />,
      },
      {
        path: "catalogs/shieldingTypes",
        element: <ShieldingTypes />,
      },
      {
        path: "catalogs/shieldingTypes/new",
        element: <NewShieldingType />,
      },
      {
        path: "catalogs/shieldingTypes/edit/:id",
        element: <EditShieldingType />,
      },
      {
        path: "catalogs/cranes",
        element: <Cranes />,
      },
      {
        path: "catalogs/cranes/newCrane",
        element: <NewCrane />,
      },
      {
        path: "catalogs/cranes/edit/:id",
        element: <EditCrane />,
      },
      {
        path: "catalogs/assistanceVehicles",
        element: <AssistanceVehicles />,
      },
      {
        path: "catalogs/assistanceVehicles/newAssistanceVehicle",
        element: <NewAssistanceVehicle />,
      },
      {
        path: "catalogs/assistanceVehicles/edit/:id",
        element: <EditAssistanceVehicle />,
      },
      {
        path: "catalogs/liftTrucks",
        element: <LiftTrucks />,
      },
      {
        path: "catalogs/liftTrucks/newLiftTruck",
        element: <NewLiftTruck />,
      },
      {
        path: "catalogs/liftTrucks/edit/:id",
        element: <EditLiftTruck />,
      },
      {
        path: "catalogs/colors",
        element: <Colors />,
      },
      {
        path: "catalogs/colors/newColor",
        element: <NewColor />,
      },
      {
        path: "catalogs/colors/edit/:id",
        element: <EditColor />,
      },
      {
        path: "catalogs/banks/newBank",
        element: <NewBank />,
      },
      {
        path: "catalogs/banks/edit/:id",
        element: <EditBank />,
      },
      {
        path: "catalogs/bankAccounts/newBankAccount",
        element: <NewBankAccount />,
      },
      {
        path: "catalogs/bankAccounts/edit/:id",
        element: <EditBankAccount />,
      },
      {
        path: "catalogs/rates/getCoords",
        element: <GetCoords />,
      },
      {
        path: "sqlView",
        element: <SqlView />,
      },
      {
        path: "auth/changePassword",
        element: <ChangeCurrentUserPassword />,
      },
      {
        path: "reports/operators-salary",
        element: <OperatorSalary />,
      },
    ],
  },
];

const AppRoute = () => {
  const [permisos, setPermisos] = useState([]);
  const [filteredMenu, setFilteredMenu] = useState([]);

  // Función para filtrar rutas según los permisos
  const filterMenuByPermissions = (menu, permissions) => {
    return menu.map((item) => {
      if (item.children) {
        item.children = filterMenuByPermissions(item.children, permissions);
      }

      // Verificar si el usuario tiene permiso para acceder a esta ruta
      const hasPermission = !item.permission || permissions.includes(item.permission);

      return hasPermission ? item : null;
    }).filter(Boolean);
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const userId = localStorage.getItem("userId");

        const response = await axiosClient.get(`/roles/${userId}`);

        const responsePermissions = await axiosClient.get(`/roles/findPermissions/${response?.data?.id}`);

        if (responsePermissions?.data) {
          const permisosExtraidos = responsePermissions.data.flatMap((item) =>
            item.permissions.map((permiso) => permiso.description)
          );

          setPermisos(permisosExtraidos);
        }
      } catch (error) {
        console.error("Error obteniendo los permisos:", error);
      }
    };

    fetchPermissions();
  }, []);

  useEffect(() => {
    if (permisos.length > 0) {
      setFilteredMenu(filterMenuByPermissions(routesConfig, permisos));
    }
  }, [permisos]);

  return filteredMenu;
};

export default AppRoute;
 */